import { createContext } from 'react'

export const ActivationContext = createContext({
  cabinetSerial: null,
  slotPosition: null,
  setCabinetData: () => {},
  clearCabinetData: () => {},
})
